module.exports = __webpack_public_path__ + "img/first.e48aa092.svg";